import React, { type CSSProperties } from "react";
import { TopButtonGroup } from "./TopButtonGroup";
import type { ButtonKey } from "../VirtualGamepad";

interface TopButtonContainerProps {
  onTouchStart: (e: React.TouchEvent, buttonKey: ButtonKey) => void;
  onTouchEnd: (e: React.TouchEvent, buttonKey: ButtonKey) => void;
  onMouseDown: (e: React.MouseEvent, buttonKey: ButtonKey) => void;
  onMouseUp: (e: React.MouseEvent, buttonKey: ButtonKey) => void;
  containerStyle?: CSSProperties;
  buttonStyles?: Partial<Record<string, CSSProperties>>;
}

export const TopButtonContainer: React.FC<TopButtonContainerProps> = ({
  onTouchStart,
  onTouchEnd,
  onMouseDown,
  onMouseUp,
  containerStyle = {},
  buttonStyles = {},
}) => {
  return (
    <div style={{ ...baseStyles.top, ...containerStyle }}>
      <TopButtonGroup
        buttonStyles={buttonStyles}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
      />
    </div>
  );
};

const baseStyles: { [key: string]: CSSProperties } = {
  top: {
    position: "absolute",
    top: 24,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    left: 0,
    right: 0,
    margin: "0 auto",
  },
};
